import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;


console.log(API_URL);

const instance = axios.create({
    baseURL: API_URL
});

instance.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['X-Api-Key'] = API_KEY;

    return config;
});

export default instance;
